class clEditAccount
{

	private m_Modal: Dialog;
	private newName: JQuery;

	constructor( vAccount: Wollmilch.AccountObject )
	{
		const editform = new Form( { tag: 'div', orientation: 'horizontal' } );
		const editGroup = editform.newFormGroup( [ 1 ] );

		const abortBtn = new Button( { title: app.getMessage( 'Aux.ABORT_BTN' ), style: 'danger',
				on: { }
		} );
		const submitBtn = new Button(
			{
				title: app.getMessage( 'Aux.SAVE_BTN' ), style: 'success',
				on:
				{
					click: () =>
					{
						if ( this.newName.val() != '' )
						{
							let vData = {};
							vData =
							{
								AccountID: vAccount.ID,
								AccountName: this.newName.val()
							};
							this.saveEditedAccount( vData );
						}
						else
						{
							app.addToast( { body: [ app.getMessage( "Account.Edit.ERROR" ) ], context: 'danger', timeout: Number(app.getConfigValue("ToastTimeout")) });
						}
					}
				}
			}
		);
		$( abortBtn.getElement() ).attr( 'data-dismiss', 'modal' );

		const in1Label = new InputLabel( { value: app.getMessage( "Account.Edit.NAME" ) } );
		const in1 = new InputText( { name: 'newName', disabled: false, value: vAccount.Username } );
		editGroup.addItem( { input: in1, label: in1Label } );

		this.m_Modal = new Dialog(
			{
				closeBtn: true,
				fade: true,
				head: [ ui.h( 4, app.getMessage( "Account.Edit.HEADER" ) ) ],
				body: [ editform.getElement() ],
				foot: [ abortBtn.getElement(), submitBtn.getElement() ],
				selfRemove: true
			}
		);

		this.newName = $( in1.getElement() );
	}

	/*
	* erstellt EingabeModal
	* @param vAccount: Account - Object, des zu aktualisierenden Accounts
	*/
	public createModalEditAccount()
	{
		$( this.m_Modal.getElement() ).modal( 'show' );
	}

	/*
	* sichert die AccountInformation per REST/api
	* @param vData: object 	- AccountID, des zu aktualisierenden Accounts
	*												- AccountName, neuer Wert
	*/
	private saveEditedAccount( vData: any )
	{
		if ( !vData.AccountID )
		{
			return;
		}

		new Wollmilch.AJAX(
		{
			url: 'account/edit/' + vData.AccountID,
			method: 'PATCH',
			data:
				{
					username: vData.AccountName
				},
			on: {
				success: () =>
				{
					return function( text: string ): void
					{
						let obj: Wollmilch.ResponseObject;
						try
						{
							obj = JSON.parse( text );
						}
						catch ( e )
						{
							alert( e.getMessage() );
							return;
						}
						if ( obj.success )
						{
							app.addToast( { body: [ app.getMessage( "Account.Edit.SUCCESS" ) ], context: 'success', timeout: Number(app.getConfigValue("ToastTimeout")) } );

							$( this.m_Modal.getElement() ).modal( 'hide' );
						}
						else
						{
							app.addToast( { body: [ app.getMessage( "Account.Edit.ERROR" ) ], context: 'danger', timeout: Number(app.getConfigValue("ToastTimeout")) } );
						}

					};
				},
				failed: ( status, xhr ): void =>
				{
					app.addToast( { timeout: Number(app.getConfigValue("ToastTimeout")), body: [xhr.responseText], context: 'danger' } );
				}
			}
		}
		).send();
	}

}
